<script setup>
defineProps([ 'size', 'type' ])
</script>

<template>
  <svg
    viewBox="0 0 63 63"
    :style="{ width: size + 'px', height: size + 'px' }"
    class="icon-toggle"
    aria-hidden="true"
  >
    <g class="icon-toggle-group">
      <g opacity="0.05">
        <rect
          class="icon-toggle-halo icon-toggle-halo-3"
          x="4"
          y="4"
          width="51"
          height="51"
          rx="25.5"
          stroke="#121E48"
          stroke-opacity="0.8"
          stroke-linejoin="bevel" />
      </g>

      <g opacity="0.2">
        <rect
          class="icon-toggle-halo icon-toggle-halo-2"
          x="9"
          y="9"
          width="41"
          height="41"
          rx="20.5"
          stroke="#121E48"
          stroke-opacity="0.8"
          stroke-linejoin="bevel" />
      </g>

      <g opacity="0.5">
        <rect
          class="icon-toggle-halo icon-toggle-halo-1"
          x="13"
          y="13"
          width="33"
          height="33"
          rx="16.5"
          stroke="#121E48"
          stroke-opacity="0.8"
          stroke-linejoin="bevel" />
      </g>

      <rect
        class="icon-toggle-outline"
        x="17"
        y="17"
        width="25"
        height="25"
        rx="12.5"
        stroke="#121E48"
        stroke-opacity="0.8"
        stroke-linejoin="bevel" />

      <circle
        class="icon-toggle-shape"
        :class="{ [`icon-toggle-${type}`]: true }"
        cx="29.5"
        cy="29.5"
        r="7.5"
        fill="#121E48"
        fill-opacity="0.8" />
    </g>
  </svg>
</template>
